import type { Location } from "@/graphql/codegen/graphql"

// O(n) time complexity where n is number of locations
// O(n) space complexity for storing unique keys
export const deduplicateLocations = <T extends { locationId: string }>(locations: T[]): T[] => {
  // Using object literal for faster key lookups compared to Map
  const uniqueLocations: Record<string, T> = {}

  // Single pass through array with direct object property access
  for (const location of locations) {
    uniqueLocations[location.locationId] = location
  }

  return Object.values(uniqueLocations)
}

export const isActiveWarehouseLocation = (location: Location): boolean =>
  location.isActive && (location.warehouseAreas?.some((warehouse) => warehouse.isActive) ?? false)

export const isActiveIncotermsLocation = (location: Location): boolean =>
  location.isActive && (!location.warehouseAreas || location.warehouseAreas.some((warehouse) => warehouse.isActive))

export const sortIncotermsLocations = (locations: Location[]): Location[] =>
  locations.slice().sort((a, b) => {
    const isActiveA = isActiveIncotermsLocation(a)
    const isActiveB = isActiveIncotermsLocation(b)

    if (isActiveA === isActiveB) {
      return a.name.localeCompare(b.name)
    }
    return isActiveA ? -1 : 1
  })
